import e from "dayjs";
// src/design/forms/datepicker/core/config/index.ts
var t = e().format("YYYY-MM-DD"), n = {
	NOT_WITHIN_ALLOWED_RANGE: "Date must be within allowed range",
	START_AND_END_DATE_BOUNDS: "Start date must be before end date"
};
export { n as ErrorMessage, t as today };

//# sourceMappingURL=index.js.map